import React from "react";
import styled from "styled-components";

const EmptyContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400;
`;
const NoDataMsg = styled.h1`
  color: #515772;
`;

function NoData() {
  return (
    <EmptyContainer>
      <NoDataMsg>No Results</NoDataMsg>
    </EmptyContainer>
  );
}

export default NoData;
